import {
  BarChart3,
  TrendingUp,
  Calculator,
  Handshake,
  MapPin,
  Phone,
  Mail,
  Clock,
  Facebook,
  Instagram,
  MessageCircle,
  Building2,
  Square,
  Search,
  RotateCcw,
  ChevronDown,
  ArrowRight,
  Calendar,
  Menu,
  X,
  Home,
  Info,
  Briefcase,
  FileText,
  User,
  Upload,
  Trash2,
  Edit3,
  Plus,
  Save,
  LogOut,
  Image,
  Map,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  BarChart3,
  TrendingUp,
  Calculator,
  Handshake,
  MapPin,
  Phone,
  Mail,
  Clock,
  Facebook,
  Instagram,
  MessageCircle,
  Building2,
  Square,
  Search,
  RotateCcw,
  ChevronDown,
  ArrowRight,
  Calendar,
  Menu,
  X,
  Home,
  Info,
  Briefcase,
  FileText,
  User,
  Upload,
  Trash2,
  Edit3,
  Plus,
  Save,
  LogOut,
  Image,
  Map,
};

export const getIcon = (name: string): LucideIcon => {
  return iconMap[name] || MapPin;
};

export const Icon: React.FC<{ name: string; className?: string }> = ({ name, className }) => {
  const Component = getIcon(name);
  return <Component className={className} />;
};
